import script from "./GuestsList.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestsList.vue?vue&type=script&setup=true&lang=js"

import "./GuestsList.vue?vue&type=style&index=0&id=a939b92c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a939b92c"]])

export default __exports__